import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { PulseLoader } from "react-spinners";

const API_URL = process.env.REACT_APP_API_URL;

const TaskView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [task, setTask] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchTask();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Format date to IST with AM/PM
  const formatDateToIST = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  // Format date only (no time)
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString();
  };

  // Get task status color class
  const getTaskStatusColor = (status) => {
    if (!status) return "badge-warning";
    const statusLower = status.toLowerCase();

    switch (statusLower) {
      case "completed":
        return "badge-success";
      case "pending":
        return "badge-warning";
      case "inprogress":
        return "badge-info";
      case "hold":
        return "badge-secondary";
      default:
        return "badge-warning";
    }
  };

  const fetchTask = async () => {
    if (!id) {
      toast.error("Task ID is missing", { autoClose: 2000 });
      navigate("/task");
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        action: "get-task-by-id",
        id: id,
      };

      const response = await axios.post(API_URL, payload);
      let responseData = response.data;

      if (typeof responseData === "string") {
        try {
          responseData = JSON.parse(responseData);
        } catch (parseError) {
          responseData = response.data;
        }
      }

      if (responseData.success === true && responseData.data) {
        setTask(responseData.data);
      } else {
        toast.error(responseData.message || "Failed to fetch task details", {
          autoClose: 2000,
        });
        navigate("/task");
      }
    } catch (error) {
      console.error("Fetch task error:", error);
      if (error.response && error.response.data) {
        let errorData = error.response.data;
        if (typeof errorData === "string") {
          try {
            errorData = JSON.parse(errorData);
          } catch (e) {
            // Use error message as is
          }
        }
        toast.error(
          errorData.message || "An error occurred while fetching task details",
          { autoClose: 2000 },
        );
      } else {
        toast.error(
          "Network error. Please check your connection and try again.",
          { autoClose: 2000 },
        );
      }
      navigate("/task");
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div>
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2 align-items-center">
              <div className="col-6 col-sm-6">
                <h1 className="m-0 txt_lft">View Task</h1>
              </div>
              <div className="col-6 col-sm-6">
                <ol className="breadcrumb justify-content-end">
                  <li className="breadcrumb-item">
                    <Link to="/task">
                      <i className="fa-solid fa-arrow-left-long" /> Back
                    </Link>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="frmwdth_cntr">
                <div className="col-lg-12">
                  <div className="card card-primary card-outline">
                    <div className="card-body text-center py-5">
                      <PulseLoader color="#1199B2" size={10} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!task) {
    return (
      <div>
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2 align-items-center">
              <div className="col-6 col-sm-6">
                <h1 className="m-0 txt_lft">View Task</h1>
              </div>
              <div className="col-6 col-sm-6">
                <ol className="breadcrumb justify-content-end">
                  <li className="breadcrumb-item">
                    <Link to="/task">
                      <i className="fa-solid fa-arrow-left-long" /> Back
                    </Link>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="frmwdth_cntr">
                <div className="col-lg-12">
                  <div className="card card-primary card-outline">
                    <div className="card-body text-center py-5">
                      <p>Task not found</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2 align-items-center">
            <div className="col-6 col-sm-6">
              <h1 className="m-0 txt_lft">View Task</h1>
            </div>
            <div className="col-6 col-sm-6">
              <ol className="breadcrumb justify-content-end">
                <li className="breadcrumb-item">
                  <Link to="/task">
                    <i className="fa-solid fa-arrow-left-long" /> Back
                  </Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="frmwdth_cntr">
              <div className="col-lg-12">
                <div className="card card-primary card-outline">
                  <form className="form-horizontal">
                    <div className="card-body">
                      <div className="form-group row">
                        <label className="col-12 col-md-4 col-form-label">
                          Task Description
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {task.taskDescription || "-"}
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Expected Completion Date
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {formatDate(task.expectedCompletedDate)}
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Assigned By
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {task.assignedBy?.name || "-"}
                            {task.assignedBy?.email && (
                              <div className="text-muted small">
                                {task.assignedBy.email}
                              </div>
                            )}
                            {task.assignedBy?.phoneNumber && (
                              <div className="text-muted small">
                                {task.assignedBy.phoneNumber}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Assigned To
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {task.assignedTo?.name || "-"}
                            {task.assignedTo?.email && (
                              <div className="text-muted small">
                                {task.assignedTo.email}
                              </div>
                            )}
                            {task.assignedTo?.phoneNumber && (
                              <div className="text-muted small">
                                {task.assignedTo.phoneNumber}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Task Status
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            <span
                              className={`badge ${getTaskStatusColor(task.taskStatus)}`}
                              style={{ fontSize: "90%", fontWeight: 550 }}
                            >
                              {task.taskStatus || "Pending"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Task Acceptance
                        </label>

                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            <span
                              className={` p-2 badge ${
                                task.taskAcceptanceStatus === "Accepted"
                                  ? "badge-success"
                                  : task.taskAcceptanceStatus === "Declined"
                                    ? "badge-danger"
                                    : "badge-warning"
                              }`}
                              style={{ fontSize: "90%", fontWeight: 550 }}
                            >
                              {task.taskAcceptanceStatus || "Pending"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Task Type
                        </label>

                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {task.taskType === "repeated"
                              ? "Repeated"
                              : "One Time"}
                          </div>
                        </div>
                      </div>
                      {task.taskType === "repeated" && (
                        <div className="form-group row align-items-center">
                          <label className="col-12 col-md-4 col-form-label">
                            Report Type
                          </label>

                          <div className="col-12 col-md-8">
                            <div className="txtdsply">
                              {task.reportType || "-"}
                            </div>
                          </div>
                        </div>
                      )}
                      {task.taskType === "repeated" &&
                        task.reportType === "weekly" && (
                          <div className="form-group row">
                            <label className="col-12 col-md-4 col-form-label">
                              Weekly Dates
                            </label>

                            <div className="col-12 col-md-8">
                              <div className="txtdsply">
                                {task.weeklyDates?.length > 0
                                  ? task.weeklyDates.map((date, index) => (
                                      <div key={index}>{formatDate(date)}</div>
                                    ))
                                  : "-"}
                              </div>
                            </div>
                          </div>
                        )}
                      {task.taskType === "repeated" &&
                        task.reportType === "monthly" && (
                          <div className="form-group row align-items-center">
                            <label className="col-12 col-md-4 col-form-label">
                              Monthly Date
                            </label>

                            <div className="col-12 col-md-8">
                              <div className="txtdsply">
                                {task.monthlyDate
                                  ? formatDate(task.monthlyDate)
                                  : "-"}
                              </div>
                            </div>
                          </div>
                        )}
                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Priority
                        </label>

                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            <span
                              className={` p-2 badge ${
                                task.priority === "Critical"
                                  ? "badge-danger"
                                  : task.priority === "High"
                                    ? "badge-warning"
                                    : task.priority === "Medium"
                                      ? "badge-info"
                                      : "badge-secondary"
                              }`}
                              style={{ fontSize: "90%", fontWeight: 550 }}
                            >
                              {task.priority || "Medium"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Email Trigger
                        </label>

                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            <span
                              className={`p-2 badge ${
                                task.emailTrigger === "active"
                                  ? "badge-success"
                                  : "badge-danger"
                              }`}
                              style={{ fontSize: "90%", fontWeight: 550 }}
                            >
                              {task.emailTrigger || "-"}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Task Duration
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {task.taskDuration || "-"}
                          </div>
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-12 col-md-4 col-form-label">
                          User Remarks
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {task.userRemarks || "-"}
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Status
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            <span
                              className={`badge ${task.status === "active" ? "badge-success" : "badge-danger"}`}
                              style={{ fontSize: "90%", fontWeight: 550 }}
                            >
                              {task.status || "-"}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Created By
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {task.createdBy?.name || "-"}
                            {task.createdBy?.email && (
                              <div className="text-muted small">
                                {task.createdBy.email}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Created On
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {formatDateToIST(task.createdAt)}
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Updated By
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {task.updatedBy?.name || "-"}
                            {task.updatedBy?.email && (
                              <div className="text-muted small">
                                {task.updatedBy.email}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Updated On
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {formatDateToIST(task.updatedAt)}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card-footer text-center">
                      <Link
                        to={`/taskEdit/${task._id}`}
                        className="btn btn-blue mr-2"
                      >
                        Edit
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskView;
